const PRODUCTION_API_URL_ERROR =
  "REACT_APP_API_URL must be set to a valid public http(s) backend URL in production.";

const isProductionBuild = () => String(process.env.NODE_ENV || "").toLowerCase() === "production";

const hasLoopbackHostname = (hostname) => {
  const normalized = String(hostname || "")
    .trim()
    .toLowerCase()
    .replace(/^\[(.*)\]$/, "$1");
  if (!normalized) return true;
  if (normalized === "localhost" || normalized === "0.0.0.0" || normalized === "::1") {
    return true;
  }
  if (/^127(?:\.\d{1,3}){3}$/.test(normalized)) {
    return true;
  }
  return false;
};

export const defaultApiBaseUrl = () => {
  if (typeof window !== "undefined") {
    const protocol = window.location?.protocol || "http:";
    const host = String(window.location?.hostname || "").toLowerCase();
    if (host === "localhost" || host === "127.0.0.1" || host === "0.0.0.0") {
      return `${protocol}//localhost:8000`;
    }
  }
  return "http://localhost:8000";
};

export const normalizeApiBaseUrl = (rawBaseUrl) => {
  const protocol =
    typeof window !== "undefined" && window.location?.protocol
      ? window.location.protocol
      : "http:";
  const value = typeof rawBaseUrl === "string" ? rawBaseUrl.trim() : "";

  if (!value) return defaultApiBaseUrl();
  if (value.startsWith("http://") || value.startsWith("https://")) {
    return value.replace(/\/+$/, "");
  }
  if (value.startsWith("//")) {
    return `${protocol}${value}`.replace(/\/+$/, "");
  }
  if (value.startsWith(":")) {
    return `${protocol}//localhost${value}`.replace(/\/+$/, "");
  }
  if (/^[a-zA-Z0-9.-]+:\d+/.test(value)) {
    return `${protocol}//${value}`.replace(/\/+$/, "");
  }
  if (value.startsWith("/")) {
    return value;
  }
  return `/${value}`;
};

const validateProductionApiBaseUrl = (baseUrl) => {
  let parsed;
  try {
    parsed = new URL(baseUrl);
  } catch (_error) {
    throw new Error(PRODUCTION_API_URL_ERROR);
  }

  if (!["http:", "https:"].includes(parsed.protocol)) {
    throw new Error(PRODUCTION_API_URL_ERROR);
  }
  if (!parsed.hostname || parsed.hostname.includes("*") || hasLoopbackHostname(parsed.hostname)) {
    throw new Error(PRODUCTION_API_URL_ERROR);
  }
  if ((parsed.pathname && parsed.pathname !== "/") || parsed.search || parsed.hash) {
    throw new Error(PRODUCTION_API_URL_ERROR);
  }
  if (parsed.username || parsed.password) {
    throw new Error(PRODUCTION_API_URL_ERROR);
  }

  return parsed.origin;
};

export const resolveApiBaseUrl = (rawBaseUrl) => {
  const value = typeof rawBaseUrl === "string" ? rawBaseUrl.trim() : "";
  if (!value) {
    if (isProductionBuild()) {
      throw new Error(PRODUCTION_API_URL_ERROR);
    }
    return defaultApiBaseUrl();
  }

  const normalized = normalizeApiBaseUrl(value);
  if (!isProductionBuild()) {
    return normalized;
  }
  return validateProductionApiBaseUrl(normalized);
};

export { PRODUCTION_API_URL_ERROR };
